import { render, staticRenderFns } from "./LayersAdding.vue?vue&type=template&id=a4a5bec2&scoped=true&"
import script from "./LayersAdding.vue?vue&type=script&lang=js&"
export * from "./LayersAdding.vue?vue&type=script&lang=js&"
import style0 from "./LayersAdding.vue?vue&type=style&index=0&id=a4a5bec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a5bec2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCol,VRow,VSubheader,VTabItem,VTreeview})
